import { useContext, useEffect, useState } from "react";

import { NotificationContext } from "shared/NotificationContext";
import "./Notifications.css";
import { NotificationType } from "shared/topchef.types"
import { useTranslation } from "react-i18next";

const Notifications = () => {
  const { t } = useTranslation();

  const { notification, clearNotification } = useContext(NotificationContext);
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    if (notification) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
      }, 5000); // Hide after 5 seconds
      return () => clearTimeout(timer);
    }
  }, [notification]);

  if (!notification || !visible) {
    return null;
  }

  const getTitle = (type: NotificationType) => {
    return type === NotificationType.error ? t('common.error') : t('common.information');
  };

  const handleClose = () => {
    //setVisible(false);
    clearNotification();
  };

  return (
    <div className={`notification ${notification.type === NotificationType.error ? "error" : "info"}`}>
      <div className="notification-header">
        <strong>{getTitle(notification.type)}</strong>
        <button className="close-btn" onClick={handleClose}>&times;</button>
      </div>
      <div className="notification-content">
        {notification.message}
      </div>
    </div>
  );
};

export default Notifications;
